<template>
    <div class="modal-iframe" >
        <iframe :src="url" class="modal-iframe__iframe"></iframe>
    </div>
</template>

<script>
export default {
    name: "ModalIframe",
    props: {
        url: {
            type: String,
        }
    }
};
</script>
